export default __webpack_public_path__ + "static/media/characterIcon.fe1a6c42.png";